module.exports = __webpack_public_path__ + "img/state-mi.42e27e4d.png";